//imports
import {
	PREFERENCES_GET_PREFERENCES_REQUEST,
	PREFERENCES_GET_PREFERENCES_RESULT,
	PREFERENCES_SAVE_PREFERENCE,
	PREFERENCES_GET_PREFERENCES_RESULT_UPDATE,
	PREFERENCES_UPDATE_PREFERENCES_OTHER,
	PREFERENCES_CLEAR_RETURNED_KEY,
	CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
	loadingPreference: false,
	preferencesCompany: [],
	preferencesUser: [],
	preferencesOther: [],
	returnServer: false,          // DEPRECATED: Kept for backward compatibility, will be removed
	returnedKeys: {},             // NEW: Per-component scoping - { [preferencesKey]: true }
	preferenceResultUpdate: false
};

//change redux object
export default (state = INIT_STATE, action) => {
	switch (action.type) {

		case PREFERENCES_GET_PREFERENCES_REQUEST:
			return { ...state, loadingPreference: true }

		case PREFERENCES_GET_PREFERENCES_RESULT:
			// Mark ALL keys as "returned" so each component can check its own key
			// Extract all unique preferenceKeys from the returned preferences
			const newReturnedKeys = {};
			if (action.payload.preferencesOther) {
				action.payload.preferencesOther.forEach(pref => {
					if (pref.preferenceKey) {
						newReturnedKeys[pref.preferenceKey] = true;
					}
				});
			}
			return { 
				...state, 
				loadingPreference: false, 
				returnServer: true,       // Keep for backward compatibility
				returnedKeys: { ...state.returnedKeys, ...newReturnedKeys },
				...action.payload 
			};

		case PREFERENCES_SAVE_PREFERENCE:
			return { ...state, returnServer: false };

		case PREFERENCES_CLEAR_RETURNED_KEY:
			// Clear a specific preferencesKey from returnedKeys
			const { preferencesKey } = action.payload;
			const updatedReturnedKeys = { ...state.returnedKeys };
			delete updatedReturnedKeys[preferencesKey];
			return { ...state, returnedKeys: updatedReturnedKeys };

		case PREFERENCES_GET_PREFERENCES_RESULT_UPDATE:
			return { ...state, loadingPreference: false, preferenceResultUpdate: action.payload };

		case PREFERENCES_UPDATE_PREFERENCES_OTHER:
			return { ...state, preferencesOther: action.payload };

		case CLEAR_REDUX:
			return ["", "PREFERENCES"].includes(action.payload.option)
				? action.payload.parameters
					? { ...state, ...action.payload.parameters }
					: { ...INIT_STATE }
				: { ...state }

		default:
			return state;
	}
};
